<template>
  <div>
    <!-- FILTROS -->
    <div class="card">
      <div class="card-header">
        <h5 class="card-title" id="accordion">Filtrar registros</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>Objeto</label>
              <select class="custom-select rounded-0" v-model="objeto" @change="buscarRegistros()">
                <option></option>
                <option value="Cadastro">Cadastro</option>
                <option value="Lance">Lance</option>
                <option value="Leilao">Leilão</option>
                <option value="Lote">Lote</option>
              </select>
            </div>
          </div>
        </div>

        <button type="button" class="btn btn-primary" @click="buscarRegistros">Buscar</button>
        <button type="button" class="btn btn-default" @click="limparFiltros" style="margin-left: 5px">Limpar filtros</button>
      </div>
    </div>

    <!-- TABELA DE registros -->
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Registros deletados</h3>
          <div class="card-tools">
            <!-- PAGINAÇÃO  -->
            <ul class="pagination pagination-sm m-0 float-right">
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

              <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
                <a
                  :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'"
                  class="page-link"
                  href="#"
                  @click="selecionarPagina(pagina)"
                >
                  {{ pagina }}
                </a>
              </li>

              <li class="page-item">
                <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
              </li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
            </ul>
          </div>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th>Id</th>
                <th>Objeto</th>
                <th>Deletado por</th>
                <th>Deletado em</th>
                <th>Mensagem exibida ao usuário</th>
                <th>Justificativa</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(registro, index) in registros" :key="registro">
                <td>{{ registro.object_id }}</td>
                <td>{{ objeto }}</td>
                <td v-if="objeto == 'lance'">{{ registro.deleted_by }} ({{ registro.apelido }})</td>
                <td v-else>{{ registro.user_id }} ({{ registro.apelido }})</td>
                <td>{{ formatDate(registro.created_at) }}</td>
                <td>{{ registro.pergunta }}</td>
                <td>
                  <span v-if="registro.motivo_cancelamento">{{ registro.motivo_cancelamento }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer clearfix">
          <!-- TOTAIS  -->
          <div style="font-size: 13px" class="float-left" aria-live="polite">
            Exibindo do {{ inicio + 1 }} ao {{ inicio + registros.length }}
            <p>Total {{ total }}</p>
          </div>

          <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

          <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="7">7</option>
            <option :value="15">15</option>
            <option :value="25">25</option>
          </select>

          <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 150px"></div>
          </div>

          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: [],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      registro_selecionado: "",
      filtro: "",
      paginas: [],
      registros: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome_contato: "",
      max_page: 0,
      editar_registro: false,
      cadastrar_registro: false,
    };
  },

  mounted() {
    console.log(this.registros);
  },

  methods: {
    buscarRegistros() {
      this.isLoading = true;

      let data = {
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      let url = null;

      if (this.objeto == "Lance") {
        url = "/admin/registros_deletados/lances/search";
      } else if (this.objeto == "Lote") {
        url = "/admin/registros_deletados/lotes/search";
      } else if (this.objeto == "Leilao") {
        url = "/admin/registros_deletados/leiloes/search";
      } else if (this.objeto == "Cadastro") {
        url = "/admin/registros_deletados/cadastros/search";
      }

      if (!url) {
        this.showErrorMessageWithButton("Ops...", "Selecione o tipo de objeto");
      } else {
        console.log("URL =");
        console.log(url);

        axios
          .post(url, data)
          .then((response) => {
            this.registros = response.data.registros;
            this.total = response.data.total;

            this.pagination(response.data);
          })
          .catch((error) => {
            this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
            console.log(error.response.data);
          });
      }
    },

    limparFiltros() {
      this.objeto = null;
      this.registros = [];
    },

    deletar(registro) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Esta ação é irreversível, deseja continuar?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: registro.id,
            };

            axios
              .post(`/admin/registro/delete`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessage("registro deletado!");
                this.buscarRegistros();
              })
              .catch((error) => {
                this.isLoading = false;
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);
      console.log("Max = " + this.max_page);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarRegistros();
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
